export const insert = "insert";
export const replace = "replace";
export const loading = "loading";
export const refresh = "refresh";
export const edit = "edit";
export const editObj = "editObj";
export const setStatusFilter = "setStatusFilter";
export const setFilters = "setFilters";
export const setGlobalFilter = "setGlobalFilter";
